import { IMetaTags } from "@components/meta-tags/types/meta-tags.types";

export function useMetaTags() {
  const setMetaTags = (data: IMetaTags) => {
    document.title = data.title;
    const metaDescription = document.querySelector(
      'meta[name^="description" i]',
    );
    if (metaDescription) {
      metaDescription.setAttribute("content", data.description);
    }

    let metaRobots = document.querySelector('meta[name="robots"]');
    if (data.robots) {
      if (!metaRobots) {
        metaRobots = document.createElement("meta");
        metaRobots.setAttribute("name", "robots");
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute("content", data.robots);
    } else if (metaRobots) {
      metaRobots.remove();
    }
  };

  return {
    setMetaTags,
  };
}
